import {useEffect, useState} from "react";
import FunctionsConfig from "../../../Functions/FunctionsConfig";
import moment from "moment/moment";
import jwt from "jsonwebtoken";
import FunctionsData from "../../../Functions/FunctionsData";
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    Stack,
    Switch,
    TextField
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import * as React from "react";
import RedeemVoucherShowWeightAddon from "./RedeemVoucherShowWeightAddon";
import RedeemVoucherWhyNotComponent from "./RedeemVoucherWhyNotComponent";
import RedeemVoucherMicrochipNumber from "./RedeemVoucherMicrochipNumber";
import RedeemVoucherRedeemButton from "./RedeemVoucherRedeemButton";
import GeneralBackdrop from "../../../Hooks/GeneralBackdrop";

/*
*  Show animal
* @param {object} rowInstance
* @param {function} setRowInstance
* @param {array} microchips
* @param {function} setAnimal
* @param {object} animal
* @param {function} setShowModal
* @param {boolean} showModal
* @param {function} reloadOriginal
* @param {boolean} verified
 */
export default function RedeemVoucherShowAnimalSingleForm({
                                                              rowInstance,
                                                              setRowInstance,
                                                              microchips,
                                                              setAnimal,
                                                              animal,
                                                              setShowModal,
                                                              showModal,
                                                              reloadOriginal,
                                                              verified
                                                          }) {

    const [showBackdrop, setShowBackdrop] = useState(false);
    const [row, setRow] = useState(rowInstance);
    const [loading, setLoading] = useState(false);

    const [mc, setMc] = useState(row.a_microchip_number || '');
    const [mcWhyNot, setMcWhyNot] = useState(row.microchip_reason_why_not || '');
    const [valid, setValid] = useState(false);
    const [primaryColor, setPrimaryColor] = useState(row.a_color_primary || '');
    const [secondaryColor, setSecondaryColor] = useState(row.a_color_secondary || '');
    const [dateSurgery, setDateSurgery] = useState(null);
    const [dateSurgeryValid, setDateSurgeryValid] = useState(false);
    const [customError, setCustomError] = useState(false);
    const [amountSurgery, setAmountSurgery] = useState(0.00);
    const [amountAllSponsor, setAmountAllSponsor] = useState(0.00);
    const [hideMicrochipNumber, setHideMicrochipNumber] = useState(false);
    const [isMicrochipAdded, setIsMicrochipAdded] = useState(-2);
    const [isCommunity, setIsCommunity] = useState(false);

    const [coloursPrimary, setColoursPrimary] = useState([]);
    const [coloursSecondary, setColoursSecondary] = useState([]);
    const [animalTypes, setAnimalTypes] = useState([]);
    const [weights, setWeights] = useState([]);

    useEffect(() => {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/voucher/id/') + rowInstance.id,
            setRow, loading, setLoading
        )
    }, [rowInstance, loading])

    useEffect(() => {
        FunctionsConfig.getPrimaryColours(row.a_type).then((r) => {
            setColoursPrimary(r);
        });

        FunctionsConfig.getSecondaryColours(row.a_type).then((r) => {
            setColoursSecondary(r);
        })

        FunctionsConfig.getAnimalTypesArray().then((r) => {
            setAnimalTypes(r);
        })

        FunctionsConfig.getWeights().then((r) => {
            setWeights(r);
        })

    }, [row.a_type])

    useEffect(() => {
        setIsCommunity(
            (
                row.campaign_target &&
                (row.campaign_target.includes('community') || row.campaign_target.includes('inspectors') || row.campaign_target.includes('outreach'))
            )
        )

        setPrimaryColor(row.a_color_primary ?? '');
        setSecondaryColor(row.a_color_secondary ?? '');
        setMcWhyNot(row.microchip_reason_why_not ?? '');
        setDateSurgery(moment(row.a_date_surgery).isValid() ? moment(row.a_date_surgery).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD"));
	    
	    setHideMicrochipNumber(row.microchip_added === -1);
		setIsMicrochipAdded(row.microchip_added > -1)
    }, [
        row.a_color_primary,
        row.microchip_reason_why_not,
        row.a_microchip_number,
        row.a_color_secondary,
        row.campaign_target,
        row.a_date_surgery,
	    row.microchip_added
    ])

    useEffect(() => {

    },[dateSurgery])

    function calcAmount() {

        let a = 0;
        FunctionsConfig.pricingMatrix(row.a_type, row.a_gender, row.a_weight, row.a_type_surgery, isCommunity).then((arr) => {
            if (arr) {
                a = parseFloat(arr.price);
                if (row.a_is_pregnant > 0) {
                    a = a + arr.pregnant_add;
                }
                if (!isCommunity) {
                    if (row.sponsor_applicant_cost > 0) {
                        a = a + parseFloat(row.sponsor_applicant_cost);
                        if (String(row.a_type_surgery) !== 'Microchip only' && row.sponsor_microchip_extra_cost > 0) {
                            a = a + parseFloat(row.sponsor_microchip_extra_cost);
                            setAmountAllSponsor(parseFloat(row.sponsor_applicant_cost) + parseFloat(row.sponsor_microchip_extra_cost));
                        } else {
                            setAmountAllSponsor(parseFloat(row.sponsor_applicant_cost));
                        }

                    }
                }
            }
            setAmountSurgery((!a) ? 0 : a);
        });

    }

    useEffect(() => {

        console.log('dateSurgery', dateSurgery);

        if (mc !== '') setMcWhyNot('');
        try {
            setValid(
                ((mc !== '' && mc.length === 15) || mcWhyNot !== '')
                && row.a_name !== ''
                && dateSurgery !== '' && dateSurgery !== null && dateSurgeryValid && moment(dateSurgery).isValid()
                && row.a_type !== '' && row.a_type !== null
                && row.a_type_surgery !== '' && row.a_type_surgery !== null
                && row.a_gender !== '' && row.a_gender !== null
                && row.a_age !== '' && row.a_age !== null && row.a_age !== 'Unknown'
                && row.a_color_primary !== '' && row.a_color_primary !== null
                && row.microchip_added !== '' && row.microchip_added !== null
                && (!['Microchip only'].includes(row.a_type_surgery) || (['Microchip only'].includes(row.a_type_surgery) && row.a_microchip_number !== ''))
                &&
                (
                    ((['Spay', 'Pregnant spay', 'Microchip only'].includes(row.a_type_surgery) && row.a_gender === 'Female'))
                    ||
                    ((['Neuter', 'Cryptorchid', 'Microchip only'].includes(row.a_type_surgery) && row.a_gender === 'Male'))
                )
                && isMicrochipAdded > -2 &&
                !microchips.includes(row.a_microchip_number) &&
                row.owner_verified === 1 &&
                (
                    moment(row.created_at).format("YYYY-MM-DD") <= moment(dateSurgery.toString()).format("YYYY-MM-DD")
                    &&
                    moment(dateSurgery.toString()).format("YYYY-MM-DD") <= moment().format("YYYY-MM-DD")
                    &&
                    moment(dateSurgery.toString()).isValid()
                )
            );

            setDateSurgeryValid(
                (
                    moment(row.created_at).format("YYYY-MM-DD") <= moment(dateSurgery.toString()).format("YYYY-MM-DD")
                    &&
                    moment(dateSurgery.toString()).format("YYYY-MM-DD") <= moment().format("YYYY-MM-DD")
                    &&
                    moment(dateSurgery.toString()).isValid()
                )
            )

        } catch (e) {
            setValid(false);
            setDateSurgeryValid(false)
        }
        calcAmount();
    }, [row, mc, mcWhyNot, dateSurgery, dateSurgeryValid, isMicrochipAdded, microchips])

    if (row.length === 0) return null;

    function updateValue(val, col) {

        let d = {...row, [col]: val};
        let payload = {[col]: val};

        if (col === 'microchip_added') {
            if (val !== -1) {
                d = {...d, ['microchip_reason_why_not']: ''};
                payload = {...payload, ['microchip_reason_why_not']: ''};
            } else {
                d = {...d, ['a_microchip_number']: ''};
	            payload = {...payload, ['a_microchip_number']: ''};
            }
        }

        if (col === 'a_type_surgery' && val === "Microchip only") {

            setIsMicrochipAdded(1);
            setHideMicrochipNumber(false);
            d = {...d, 'microchip_reason_why_not': '', 'microchip_added': '1'};
            payload = {...payload, 'microchip_reason_why_not': '', 'microchip_added': '1'};
        }
		
        if (col === 'a_type_surgery' && val !== "Microchip only") {
            setIsMicrochipAdded(parseInt(d.microchip_added));
        }

        let requestOptionsVoucher = {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'token': localStorage.vTkn},
            body: JSON.stringify(payload)
        };

        fetch(FunctionsData.getApiUrl("/api/voucher/update/") + row.id, requestOptionsVoucher)
            .then(response => response.json())
            .then(() => {
                setRow(d);
            })
    }

    function updateValueBool(val, col) {

        let requestOptionsVoucher = {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'token': localStorage.vTkn},
            body: JSON.stringify({
                [col]: (val === true) ? 1 : 0
            })
        };

        fetch(FunctionsData.getApiUrl("/api/voucher/update/") + row.id, requestOptionsVoucher)
            .then(response => response.json())
            .then((res) => {
                setRow({...row, [col]: (val === true) ? 1 : 0});
            })

    }

    function redeemVoucher() {
        if (amountSurgery === false || (amountSurgery === 0 && String(row.a_type_surgery).trim() !== 'Microchip only')) {
            setCustomError(true);
            return;
        }

        setShowBackdrop(true);
        const obj = row;
        const tkn = jwt.decode(localStorage.getItem('vTkn'));

        let requestOptionsVoucher = {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'token': localStorage.vTkn},
            body: JSON.stringify({
                a_name: obj.a_name,
                vet_id: tkn.id,
                a_gender: obj.a_gender,
                a_type: obj.a_type,
                a_microchipped: obj.a_microchipped,
                a_is_pregnant: obj.a_is_pregnant,
                a_was_pregnant: obj.a_was_pregnant,
                a_age: obj.a_age,
                a_part_colony: obj.a_part_colony,
                a_microchip_number: obj.a_microchip_number,
                microchip_added: obj.microchip_added,
                microchip_reason_why_not: obj.microchip_reason_why_not,
                a_color_primary: obj.a_color_primary,
                a_color_secondary: obj.a_color_secondary,
                a_type_surgery: obj.a_type_surgery,
                a_date_surgery: dateSurgeryValid ? dateSurgery : null,
                a_surgery_amount: amountSurgery,
                is_redeemed: 1,
                modified_at: new Date().toISOString(),
                redeemed_at: new Date().toISOString()
            })
        };

        fetch(FunctionsData.getApiUrl("/api/voucher/update/") + row.id, requestOptionsVoucher)
            .then((response) => {
                response.json()
            })
            .then((res) => {
                reloadOriginal(true);
                setShowModal(false);
            })
            .then(r => {
                let requestOptionsVoucher = {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json', 'token': localStorage.vTkn}
                };
                fetch(FunctionsData.getApiUrl("/api/merco/integration/redeemed/") + row.sn, requestOptionsVoucher)
                    .then((response) => {
                        response.json()
                    })
                    .then((res) => {
                        // send to API log
                        FunctionsData.fetchDataPost(
                            res, FunctionsData.getApiUrl("/api/merco/integration/redeemed/") + row.sn
                        ).then(
                            (r) => {
                                setShowBackdrop(false);
                            }
                        )
                    })
            });

    }

    async function reissueAndRedeemVoucher() {

        setShowBackdrop(true);
        const obj = row;
        const tkn = jwt.decode(localStorage.getItem('vTkn'));

        let requestOptionsVoucher = {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'token': localStorage.vTkn},
            body: JSON.stringify({
                vet_id: tkn.id,
                a_name: obj.a_name,
                a_gender: obj.a_gender,
                a_type: obj.a_type,
                a_microchipped: obj.a_microchipped,
                a_is_pregnant: obj.a_is_pregnant,
                a_was_pregnant: obj.a_was_pregnant,
                a_age: obj.a_age,
                a_part_colony: obj.a_part_colony,
                a_microchip_number: obj.a_microchip_number,
                microchip_added: obj.microchip_added,
                microchip_reason_why_not: obj.microchip_reason_why_not,
                a_color_primary: obj.a_color_primary,
                a_color_secondary: obj.a_color_secondary,
                a_type_surgery: obj.a_type_surgery,
                a_date_surgery: dateSurgeryValid ? dateSurgery : null,
                a_surgery_amount: amountSurgery,
                is_redeemed: 1,
                modified_at: new Date().toISOString(),
                redeemed_at: new Date().toISOString(),
                owner_first: obj.owner_first,
                owner_last: obj.owner_last,
                owner_street: obj.owner_street,
                owner_suburb: obj.owner_suburb,
                owner_city: obj.owner_city,
                owner_postcode: obj.owner_postcode,
                owner_email: obj.owner_email,
                owner_phone: obj.owner_phone,
                owner_formatted_address: obj.formatted_address,
                owner_verified: 1,
                owner_email_allowed: obj.owner_email_allowed
            })
        };

        //console.log('requestOptionsVoucher',requestOptionsVoucher,obj.microchip_added);
        // return false;

        const x = await fetch(FunctionsData.getApiUrl("/api/voucher/reissue/") + row.sn, requestOptionsVoucher)
            .then(response => {
                //console.log('/api/voucher/reissue/', response);
                if (response.status > 299) {
                    //console.log('response.status', response.status);
                    return false;
                }
                return response.json();
            })
            .then((res) => {
                //console.log("/api/voucher/reissue/" + row.sn, res);
                reloadOriginal(true);
                setShowModal(false);
                try {
                    return res.data
                } catch (e) {
                    return null;
                }
            });

        //console.log('x', x);
        if (typeof x !== 'undefined' && x !== null && String(x) !== '') {
            let requestOptionsVoucherNew = {
                method: 'POST',
                headers: {'Content-Type': 'application/json', 'token': localStorage.vTkn}
            };

            await fetch(FunctionsData.getApiUrl("/api/merco/integration/issued/") + x, requestOptionsVoucherNew)
                .then(response => response.json())
                .then((res) => {
                    //console.log("/api/merco/integration/issued/" + x, res);
                    FunctionsData.fetchDataPost(
                        res, FunctionsData.getApiUrl("/api/merco/integration/issued/") + x,
                        x, tkn.id
                    );
                });

            await fetch(FunctionsData.getApiUrl("/api/merco/integration/redeemed/") + x, requestOptionsVoucher)
                .then(response => response.json())
                .then((res) => {
                    //console.log("/api/merco/integration/redeemed/" + x, res);
                    FunctionsData.fetchDataPost(
                        res, FunctionsData.getApiUrl("/api/merco/integration/redeemed/") + x,
                        x, tkn.id
                    ).then((r) => setShowBackdrop(false));
                })
        }


    }

    return (
        <GeneralBackdrop enabled={showBackdrop}>
            <div className={"animal-selected-box"}>
                <ShowIsAlreadyRedeemed row={row}/>
                <div>
                    <TextField
                        error={(row.a_name === '')}
                        size={"full"}
                        value={row.a_name}
                        label={"Name: " + row.a_name}
                        type="text"
                        onBlur={
                            (e) => {
                                updateValue(e.target.value, 'a_name');
                                setRow({...row, a_name: e.target.value})
                            }
                        }
                        onChange={(e) => {
                            setRow({...row, a_name: e.target.value})
                        }}
                        sx={{m: 1, width: 'calc(100% - 20px)'}}
                    />

                    <Autocomplete
                        disableClearable
                        disabled
                        size={"full"}
                        value={row.a_type}
                        options={animalTypes}
                        sx={{m: 1, minWidth: '43%'}}
                        renderInput={(params) =>
                            <TextField {...params}
                                       error={row.a_type === '' || row.a_type === null}
                                       label="Type"/>
                        }
                        onChange={(e, v) => updateValue(v, 'a_type')}
                    />

                    <Stack direction={{xs: 'column', sm: 'row'}}
                           spacing={{xs: 1, sm: 2, md: 4}}
                           sx={{m: 1}}
                    >
                        <Autocomplete
                            disableClearable
                            size={"full"}
                            value={row.a_gender}
                            id="combo-box-demo"
                            options={FunctionsConfig.getGendersVet()}
                            sx={{width: '100%', display: (row.a_type === 'Rabbit') ? 'none' : null}}
                            renderInput={(params) =>
                                <TextField {...params}
                                           error={row.a_gender === '' || row.a_gender === null || row.a_gender === 'Unknown'}
                                           label="Sex"/>
                            }
                            onChange={(e, v) => {
                                updateValue('', 'a_type_surgery');
                                updateValue(v, 'a_gender');
                                setAmountSurgery(0);
                                return false;
                            }}
                        />
                        <Autocomplete
                            disableClearable
                            size={"full"}
                            value={row.a_age}
                            id="combo-box-demo"
                            options={FunctionsConfig.getAges()}
                            sx={{width: '100%', display: (row.a_type === 'Rabbit') ? 'none' : null}}
                            renderInput={(params) =>
                                <TextField {...params}
                                           error={row.a_age === '' || row.a_age === null || row.a_age === 'Unknown'}
                                           label="Age"
                                />
                            }
                            onChange={(e, v) => {
                                updateValue(v, 'a_age');
                                return false;
                            }}
                        />
                    </Stack>

                    <Stack direction={{xs: 'column', sm: 'row'}}
                           spacing={{xs: 1, sm: 2, md: 4}}
                           sx={{m: 1, marginTop: 1}}
                    >
                        <Autocomplete
                            disableClearable
                            error={primaryColor === ''}
                            size={"full"}
                            value={primaryColor}
                            id="combo-primaryColor"
                            options={coloursPrimary}
                            sx={{width: '100%', display: (row.a_type === 'Rabbit') ? 'none' : null}}
                            renderInput={(params) =>
                                <TextField {...params}
                                           error={primaryColor === '' || primaryColor === null || primaryColor === 'Unknown'}
                                           label="Primary colour"/>
                            }
                            onChange={(e, v) => {
                                setPrimaryColor(v);
                                updateValue(v, 'a_color_primary');
                                setRow({...row, a_color_primary: v})
                                return false;
                            }}
                        />
                        <Autocomplete
                            disableClearable
                            error={primaryColor === ''}
                            size={"full"}
                            value={secondaryColor}
                            id="combo-secondaryColor"
                            options={coloursSecondary}
                            sx={{width: '100%', display: (row.a_type === 'Rabbit') ? 'none' : null}}
                            renderInput={(params) =>
                                <TextField {...params}
                                           label="Secondary colour"/>
                            }
                            onChange={(e, v) => {
                                setSecondaryColor(v);
                                updateValue(v, 'a_color_secondary');
                                setRow({...row, a_color_secondary: v})
                                return false;
                            }}
                        />

                    </Stack>

                    <RedeemVoucherShowWeightAddon row={row} weights={weights} updateValue={updateValue}/>

                    <Stack direction={{xs: 'column', sm: 'row'}}
                           spacing={{xs: 1, sm: 2, md: 4}}
                           sx={{display: (['Rabbit', 'Dog'].includes(row.a_type)) ? 'none' : null}}
                    >

                        <FormControlLabel control={<Switch checked={(row.a_is_pregnant > 0)}
                                                           onChange={(e) => updateValueBool(e.target.checked, 'a_is_pregnant')}/>}
                                          size={"small"}
                                          sx={{m: 1}} label="Is pregnant"
                        />
                        <FormControlLabel control={<Switch checked={(row.a_was_pregnant > 0)}
                                                           onChange={(e) => updateValueBool(e.target.checked, 'a_was_pregnant')}/>}
                                          size={"small"}
                                          sx={{m: 1}}
                                          label="Recently gave birth"/>
                    </Stack>

                    <hr/>
                    <FormControl component="fieldset" sx={{m: 1}}>
                        <FormLabel component="legend">Microchip information</FormLabel>
                        <RadioGroup row aria-label="microchip" name="row-radio-buttons-group">
                            {
                                (row.a_type_surgery !== 'Microchip only') ?
                                    <>
                                        <FormControlLabel value="0"
                                                          control={<Radio
                                                              sx={{color: (isMicrochipAdded < -1) ? "red" : "auto"}}
                                                              checked={(row.microchip_added === 0)}
                                                              onClick={(e) => {
                                                                  setIsMicrochipAdded(2);
                                                                  setHideMicrochipNumber(false);
                                                                  updateValue(0, 'microchip_added');
                                                              }}/>} label={ 'Existing Microchip' }
                                        />
                                        <FormControlLabel value="1"
                                                          control={<Radio
                                                              sx={{color: (isMicrochipAdded < -1) ? "red" : "auto"}}
                                                              checked={(row.microchip_added === 1)}
                                                              onClick={(e) => {
                                                                  setIsMicrochipAdded(1);
                                                                  setHideMicrochipNumber(false);
                                                                  updateValue(1, 'microchip_added');
                                                              }}/>} label={ 'New Microchip ' }
                                        />
                                        <FormControlLabel value="-1"
                                                          control={<Radio
                                                              sx={{color: (isMicrochipAdded < -1) ? "red" : "auto"}}
                                                              checked={(row.microchip_added === -1)}
                                                              onClick={(e) => {
                                                                  updateValue(-1, 'microchip_added');
                                                                  setIsMicrochipAdded(0);
                                                                  setHideMicrochipNumber(true);
                                                                  setMc('');
                                                              }}/>} label="No Microchip"/>
                                    </>
                                    :
	                                <FormControlLabel value={isMicrochipAdded}
	                                                  control={<Radio
		                                                  sx={{color: (isMicrochipAdded === 1) ? "auto" : "red"}}
		                                                  checked={(row.microchip_added === 1)}
		                                                  onClick={(e) => {
			                                                  setMc('');
			                                                  setIsMicrochipAdded(1);
			                                                  setHideMicrochipNumber(false);
			                                                  updateValue(1, 'microchip_added');
		                                                  }}/>} label={ 'New Microchip' }
	                                />
                            }

                        </RadioGroup>
                    </FormControl>

                    <Stack direction={{xs: 'column', sm: 'row'}}
                           spacing={{xs: 1, sm: 2, md: 4}}
                           sx={{m: 1}}
                    >
                        {
                            (isMicrochipAdded > -1) ?
                                <RedeemVoucherMicrochipNumber
                                    mcWhyNot={mcWhyNot}
                                    setMcWhyNot={setMcWhyNot}
                                    mc={mc}
                                    row={row}
                                    updateValue={updateValue}
                                    setRow={setRow}
                                    hideMicrochipNumber={hideMicrochipNumber}
                                    setMc={setMc}
                                    microchips={microchips}
                                />
                                : undefined
                        }

                        <RedeemVoucherWhyNotComponent
                            mcWhyNot={mcWhyNot}
                            setMcWhyNot={setMcWhyNot}
                            mc={mc}
                            row={row}
                            updateValue={updateValue}
                            setRow={setRow}
                            hideMicrochipNumber={hideMicrochipNumber}
                        />

                    </Stack>
                    <hr/>
                    <Stack direction={{xs: 'column', sm: 'row'}}
                           spacing={{xs: 1, sm: 2, md: 4}}
                           sx={{m: 1, marginTop: 3}}
                    >
                        <TextField
                            error={dateSurgery === '' || dateSurgery === null || !dateSurgeryValid}
                            sx={{width: '100%'}}
                            label={"Date of procedure"}
                            type={"date"}
                            value={dateSurgery}
                            focused
                            // disabled
                            onKeyDown={(e) => {
                                // if(!e.key.includes('Arrow')) {
                                // 	e.preventDefault();
                                // }
                            }}
                            onChange={(e) => {
                                setDateSurgery(moment(e.target.value).isValid() ? moment(e.target.value).format('YYYY-MM-DD') : null);
                            }}
                            onBlur={
                                (e) => {
                                    updateValue(moment(e.target.value).isValid() ? moment(e.target.value).format('YYYY-MM-DD') : null, 'a_date_surgery');
                                    setRow({...row, a_date_surgery: e.target.value})
                                }
                            }
                            InputProps={{
                                inputProps: {
                                    readonly: true,
                                    min: moment(row.created_at).format("YYYY-MM-DD"),
                                    max: moment().format("YYYY-MM-DD"),
                                    onKeyDown: (e) => {
                                        if (e?.preventDefault) {
                                            e?.preventDefault();
                                            e?.stopPropagation();
                                        }
                                    },
                                }
                            }}
                        />
                        <Autocomplete
                            disableClearable
                            id={"a_type_surgery_form_field"}
                            size={"full"}
                            value={row.a_type_surgery}
                            options={
                                (row.a_gender === 'Male') ?
                                    FunctionsConfig.getTypeOfSurgeryByType('Male', row.a_type) :
                                    FunctionsConfig.getTypeOfSurgeryByType('Female', row.a_type)
                            }
                            sx={{width: '100%'}}
                            renderInput={(params) =>
                                <TextField {...params}
                                           error={
                                               row.a_type_surgery === '' ||
                                               row.a_type_surgery === 'null' ||
                                               row.a_type_surgery === null ||
                                               ((!['Spay', 'Pregnant spay', 'Microchip only'].includes(row.a_type_surgery) && row.a_gender === 'Female'))
                                               ||
                                               ((!['Neuter', 'Cryptorchid', 'Microchip only'].includes(row.a_type_surgery) && row.a_gender === 'Male'))
                                           }
                                           label="Procedure"
                                />
                            }
                            onChange={(e, v) => updateValue(v, 'a_type_surgery')}
                        />

                    </Stack>

                </div>

                <ShowPrice row={row} customError={customError} dateSurgeryValid={dateSurgeryValid} amountAllSponsor={amountAllSponsor}
                           amountSurgery={amountSurgery}/>

                <div>
                    <RedeemVoucherRedeemButton
                        redeemVoucher={redeemVoucher}
                        reissueAndRedeemVoucher={reissueAndRedeemVoucher}
                        sn={row.sn}
                        row={row}
                        valid={valid}
                        setShowModal={setShowModal}
                    />
                </div>
            </div>
        </GeneralBackdrop>
    )
}

/*
* ShowPrice
* @param amountSurgery
* @param row
* @param dateSurgeryValid
* @param amountAllSponsor
 */
const ShowPrice = ({amountSurgery, row, dateSurgeryValid, amountAllSponsor, customError}) => {

    if (amountSurgery === false || (amountSurgery === 0 && String(row.a_type_surgery).trim() !== 'Microchip only')) return (
        <div style={{margin: 10, color: 'red'}}>

            {(row.a_type.toLowerCase() === 'cat') ? <>Please confirm animal type, sex, age and procedure to determine the
                cost.</> : null}
            {(row.a_type.toLowerCase() === 'dog') ? <>Please confirm animal type, weight and procedure to determine
                the cost.</> : null}
            {(row.a_type.toLowerCase() === 'rabbit') ? <>Please confirm animal type to determine the
                cost.</> : null}
            {
                (row.sponsor_id > 0) ?
                    <span>&nbsp;This voucher does not incur a fee for your client.</span>
                    : undefined
            }
            {
                (dateSurgeryValid === true) ?
                    ""
                    : <div style={{color: 'red'}}>Date of procedure is outside the allowed range.</div>
            }
        </div>
    ) 
    
    if(customError) return (
        <div style={{margin: 10, color: 'red'}}>Something went wrong, click "Redeem" to try again.</div>
    ) 
        
    return <ShowSurgeryCost row={row} amountSurgery={amountSurgery} dateSurgeryValid={dateSurgeryValid}
                            amountAllSponsor={amountAllSponsor}/>
}

/*
* ShowSurgeryCost
* @param amountSurgery
* @param row
* @param dateSurgeryValid
* @param amountAllSponsor
 */
const ShowSurgeryCost = ({row, amountSurgery, dateSurgeryValid, amountAllSponsor}) => {
    return (
        <div style={{margin: 10}}>
            Current cost: NZD {amountSurgery}.&nbsp;
            {
                (!(row.campaign_target.includes('community') || row.campaign_target.includes('inspectors') || row.campaign_target.includes('outreach')) && row.sponsor_id > 0 && row.sponsor_applicant_cost > 0) ? "This amount includes $" + amountAllSponsor + " paid on behalf of the owner." : undefined
            }
            {
                (dateSurgeryValid === true) ?
                    ""
                    : <div style={{color: 'red'}}>Surgery date is outside the allowed range.</div>
            }
        </div>
    )
}

/*
* RedeemVoucherRedeemButton
* @param {object} row
*
 */
const ShowIsAlreadyRedeemed = ({row}) => {
    if (row.is_redeemed !== 1) return null;

    return (
        <div style={{background: 'rgba(255,0,0,0.5)', width: 'calc(100% - 60px)', padding: 20, margin: 10}}>
            <h3 style={{lineHeight: '1.4em'}}>Careful, you are trying to redeem a voucher that has already been
                redeemed. Please make sure this is intended.</h3>
        </div>
    )
}
